import useTranslate from "ui/locale/hooks/useTranslate";
import Form from "ui/common/components/input/Form/Form";
import { Button, Col, Typography } from "@commonlibs";
import { useTheme } from "styled-components";
import clsx from "clsx";
import { OTPFormFields, OTPFormProps } from "./OtpForm.types";
import useOtpForm from "./hooks/useOtpForm";
import { CodeFieldRoot } from "./OtpForm.styles";

function OTPForm(props: OTPFormProps) {
    const translate = useTranslate();
    const { spacing } = useTheme();

    const { code, setCode, handleRegenerateOTP, handleSubmit, isValidatingOtp, isValidateButtonTriggered } = useOtpForm(props);

    return (
        <>
            <Form className={clsx("otp-form", props.className)} onSubmit={handleSubmit} gap={6}>
                <Typography textAlign="center" variant="h4Strong" textTransform="uppercase">
                    {translate("enterOtp")}
                </Typography>
                <Typography textAlign="center" variant="body2Regular">
                    {translate("otpModalText")}
                </Typography>
                <CodeFieldRoot
                    type="numeric"
                    name={OTPFormFields.CODE}
                    digits={6}
                    label={translate("enterHereVerificationCode")}
                    value={code}
                    onChange={setCode}
                    required
                    LabelProps={{ alignment: "center" }}
                />
                <Col alignItems="center" gap={spacing[1]} style={{ marginTop: "10px" }}>
                    <Button type="submit" variant="primary" loading={props.isLoading || isValidatingOtp} fullWidth>
                        {translate("continue")}
                    </Button>
                    <Button
                        disabled={props.isLoading || isValidatingOtp || !isValidateButtonTriggered}
                        variant="text"
                        onClick={props?.onRegenerateOtp || handleRegenerateOTP}
                    >
                        {translate("sendCodeAgain")}
                    </Button>
                </Col>
            </Form>
        </>
    );
}

export default OTPForm;
